// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"46bcefa1","239":"24efb9f3","455":"77814551"}[chunkId] + ".chunk.js";
};